/**
 * 提示信息类型
 */

export enum CaseStatus {
  IN_PROGRESS = 'A',
  CANCELED = 'R',
  COMPLETED = 'F',
  DELETED = 'X'
}

export enum CaseType {
  // order case
  ORDER_CASE = 'O',
  // no order case
  NO_ORDER_CASE = 'N'
}

export const LA_TIMEZONE_ADDR = 'America/Los_Angeles';
